"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var propTypes = {
    color: PropTypes.string
};
var defaultProps = {
    color: undefined
};
/**
 * This is the [ColorStripe](#!/ColorStripe) component.
 *
 * The `ColorStripe` component places a colored strip across the entire page width
 */
var ForwardedColorStripe = function (props, ref) {
    var id = props.id, children = props.children, color = props.color, className = props.className, _a = props.style, style = _a === void 0 ? {} : _a, otherProps = __rest(props, ["id", "children", "color", "className", "style"]);
    var componentClassName = classNames(className, 'ee_color-stripe__wrapper');
    var margin = style.margin, marginTop = style.marginTop, marginBottom = style.marginBottom, otherStyles = __rest(style, ["margin", "marginTop", "marginBottom"]);
    var wrapperStyle = {
        backgroundColor: color,
        margin: margin,
        marginTop: marginTop,
        marginBottom: marginBottom
    };
    return (React.createElement("div", { id: id, style: wrapperStyle, className: "ee_color-stripe", ref: ref },
        React.createElement("div", __assign({}, otherProps, { style: otherStyles, className: componentClassName }), children)));
};
exports.ColorStripe = React.forwardRef(ForwardedColorStripe);
exports.ColorStripe.displayName = "ColorStripe";
exports.ColorStripe.defaultProps = defaultProps;
exports.ColorStripe.propTypes = propTypes;
exports.default = exports.ColorStripe;
//# sourceMappingURL=ColorStripe.js.map